import { useEffect, useState } from "react";

export default function BookPanel() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <aside
      style={{
        padding: isMobile ? "20px 10px" : "52px 40px",
        borderRight: "1px solid rgba(26,22,17,0.12)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h3 className="text-sm font-medium">
        2026 · PUBLISHER
      </h3>

      <img
        src="/images/decolonizingmission.jpeg"
        alt="Decolonizing Mission"
        style={{
          height: isMobile ? "180px" : "288px",
          width: "auto",
          objectFit: "cover",
          marginBottom: "8px",
        }}
      />
    </aside>
  );
}